import Paragraph from '@tiptap/extension-paragraph';
import { type Node } from '@tiptap/pm/model';
import { type Editor, ReactNodeViewRenderer } from '@tiptap/react';

import { ContentParagraphView } from './content-paragraph-view';

export const ContentParagraph = Paragraph.extend({
  addAttributes() {
    const { addAttributes } = Paragraph.config;
    let attributes = {};
    if (typeof addAttributes === 'function') {
      attributes = addAttributes.bind(this)();
    }
    return {
      ...attributes,
      hideDragHandle: {
        default: false,
        rendered: false,
      },
      isChild: {
        default: false,
        rendered: false,
      },
      isDirectChildOfDoc: {
        default: null,
        rendered: false,
        parseHTML: (element) => {
          const insideTable = element.closest('[data-inside-table="true"]');
          return insideTable != null ? false : null;
        },
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ContentParagraphView);
  },
  draggable: true,
});

export function setupParagraphAttributes(getPos: () => number, node: Node, editor: Editor) {
  if (editor == null || typeof getPos() !== 'number' || node.firstChild == null) {
    return;
  }
  const { tr } = editor.state;
  tr.setNodeAttribute(getPos() + 1, 'hideDragHandle', true);
  tr.setNodeAttribute(getPos() + 1, 'isChild', true);
  editor.view.dispatch(tr);
}
